import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  /**
   * Same wrap/stack rules as the parent page: the pair of cost tiles used to
   * be an unwrapped row, so inside the already-narrow result panel it overflowed
   * well before the viewport did.
   */
  divContentTCO: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "15px",
    "& > *": {
      flex: "1 1 240px",
      minWidth: 0,
    },
    "@media (max-width:899.95px)": {
      flexDirection: "column",
      "& > *": { flex: "1 1 auto" },
    },
  },

  skeletonCard: {
    borderRadius: "15px",
  },

  divResultSearch: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    padding: "30px 0px 0px 0px",
  },
  divTextResult: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
  },
});

export default useStyles;
